import { useCallback, useState } from 'react';
import { useCookies } from 'react-cookie';
import axios from 'axios';
import MenuDerechoEstados from '../../general/MenuDerechoEstados';
import './nuevoStroLight.css';
import Swal from 'sweetalert2';
import { useActualizarSiniestro } from '../../../context/ActualizarSiniestro';
export default function ModuloGeneralStroNuevoLight({ denuncia, estadosValores, reclamos, terminoCargarTodoImportante }) {
  const [opacity, setOpacity] = useState(0);
  const [cookies] = useCookies(['user'], ['asignado']);
  const {
    selectedOption,
    setSelectedOption,
    fechaRec,
    setFechaRec,
    sicobeOption,
    setSicobeOption,
    responsabilidad,
    setResponsabilidad,
    descStro,
    setDescStro,
    prioridad,
    setPrioridad,
    vencimiento,
    setVencimiento,
    monto,
    setMonto,
    comercial,
    setComercial,
    porcentaje,
    setPorcentaje,
    aceptacion,
    setAceptacion,
    ordenDePago,
    setOrdenDePago,
    guardarCambios,
  } = useActualizarSiniestro();
  // Funcion Transformar Fecha
  const today = new Date();
  let day = today.getDate();
  let month = today.getMonth() + 1;
  const year = today.getFullYear();
  day = day < 10 ? '0' + day : day;
  month = month < 10 ? '0' + month : month;
  const formattedDate = day + '/' + month + '/' + year;
  function getCurrentTime() {
    const now = new Date();
    let hour = now.getHours();
    let minute = now.getMinutes();
    minute = minute < 10 ? '0' + minute : minute;
    return hour + ':' + minute;
  }
  const currentTime = getCurrentTime();
  // Array de estados y asignados
  const optionsCarga = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'StellaM', label: 'StellaM', key: 3 },
    { value: 'DanielaM', label: 'DanielaM', key: 4 },
    { value: 'rosario', label: 'rosario', key: 5 },
  ];
  const optionsChoque = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Maurom', label: 'Maurom', key: 12 },
    { value: 'ClaudiaF', label: 'ClaudiaF', key: 13 },
    { value: 'Gian', label: 'Gian', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  const optionsContractuales = [
    { value: 'JuanG', label: 'JuanG', key: 1 },
    { value: 'LucaP', label: 'LucaP', key: 2 },
    { value: 'DanielaM', label: 'DanielaM', key: 3 },
    { value: 'DiegoD', label: 'DiegoD', key: 4 },
    { value: 'DiegoS', label: 'DiegoS', key: 5 },
    { value: 'OrelyC', label: 'OrelyC', key: 6 },
    { value: 'StellaM', label: 'StellaM', key: 7 },
    { value: 'LucianaF', label: 'LucianaF', key: 8 },
    { value: 'CandelaS', label: 'CandelaS', key: 9 },
    { value: 'MagaliG', label: 'MagaliG', key: 10 },
    { value: 'PilarS', label: 'PilarS', key: 11 },
    { value: 'Augusto', label: 'Augusto', key: 12 },
    { value: 'PaulaC', label: 'PaulaC', key: 13 },
    { value: 'MariaE', label: 'MariaE', key: 14 },
    { value: 'rosario', label: 'rosario', key: 15 },
  ];
  // Fin
  const handleChange = event => {
    if (cookies?.user?.titulo === 'lector') {
      return;
    }
    setSelectedOption(event.target.value);
  };
  const optionsPrioridad = [
    { label: 'NINGUNA', value: 0 },
    { label: 'BAJA', value: 1 },
    { label: 'MEDIA', value: 2 },
    { label: 'ALTA', value: 3 },
  ];
  const prioridadSeleccionado = optionsPrioridad.find(p => p.value === Number(prioridad));
  //
  const cbtSicobe = [
    { value: 1, label: 'CON COBERTURA', key: 1 },
    { value: 2, label: 'EN REVISION', key: 2 },
    { value: 3, label: 'CON COBERTURA ANALIZADO POR COBRANZAS', key: 3 },
    { value: 4, label: 'SIN COBERTURA ANALIZADO POR COBRANZAS', key: 4 },
    { value: 5, label: 'PARA IMPUTAR', key: 5 },
  ];
  const handleChangeSicobe = event => {
    if (cookies?.user?.titulo === 'lector') {
      return;
    }
    setSicobeOption(event.target.value);
  };
  //
  const handleChangePrioridad = event => {
    if (cookies?.user?.titulo === 'lector') {
      return;
    }
    setPrioridad(event.target.value);
  };
  //
  const [botonOff, setBotonOff] = useState(0);
  //
  const handleGuardar = async () => {
    Swal.fire({
      title: 'Actualizando...',
      text: 'Por favor, espera un momento.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      await guardarCambios();
      Swal.fire({
        icon: 'success',
        title: 'Actualizado',
        text: 'El siniestro fue actualizado correctamente.',
        timer: 2000,
        showConfirmButton: false,
      });
      setTimeout(() => {
        window.location.reload();
      }, 2200);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un problema al actualizar.',
      });
    }
  };

  return (
    <>
      <section className='moduloActualizacionStro1LightContainer' style={{ opacity: opacity === 1 ? 0.25 : 1 }}>
        {opacity === 1 ? (
          <div className='SpinnerInTheMiddle'>
            <div class='spinner-border text-success center' role='status'>
              <span class='visually-hidden center'>Loading...</span>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className='d-flex gap-3 align-items-center'>
          <div className='nuevoSelectAsignado'>
            <select
              value={selectedOption}
              onChange={handleChange}
              className='select'
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante}
              style={terminoCargarTodoImportante ? { cursor: 'pointer' } : null}>
              <option value=''>Asignar A</option>
              {cookies.user.depto === 'cargas' ? (
                optionsCarga.map(option => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))
              ) : cookies.user.depto === 'choques' ? (
                optionsChoque.map(option => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))
              ) : cookies.user.depto === 'contractuales' ? (
                optionsContractuales.map(option => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))
              ) : (
                <></>
              )}
            </select>
          </div>
          <div className=''>
            <span className='nuevoSpanCodigoGeneral d-block'>Código:</span>
            <span className='nuevoCodigoGral'>{reclamos.length > 0 ? reclamos.map(r => r.catStro).join(' - ') : responsabilidad}</span>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <button
              className='nuevoActualizarModuloGral d-flex gap-2 justify-content-center align-items-center'
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : false}
              onClick={e => handleGuardar()}>
              Act. Stro<i class='bi bi-file-earmark-text-fill'></i>
            </button>
          </div>
        </div>
        <div className='rowModuloActualizacion mt-3'>
          <div className='colModuloActualizacion'>
            <span className='nuevoSpanModuloGralValores'>Cbt Sicobe</span>
            <div className={`nuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}>
              <select
                value={sicobeOption}
                onChange={handleChangeSicobe}
                className='select2AModuloActualizacionStro1Light textoNuevaBurbujaGralValoresLight'
                disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
                style={{
                  cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
                }}>
                <option value=''></option>
                {cbtSicobe.map(option => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className='colModuloActualizacion'>
            <span className='nuevoSpanModuloGralValores'>F. Rec Recibido</span>
            <input
              type='date'
              value={fechaRec}
              onChange={e => setFechaRec(e.target.value)}
              className={`nuevaBurbujaGralValoresLight textoNuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}
            />
          </div>
          <div className='colModuloActualizacion'>
            <span className='nuevoSpanModuloGralValores'>Prioridad</span>
            <div className={`nuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}>
              <select
                value={prioridad}
                onChange={handleChangePrioridad}
                className='select2AModuloActualizacionStro1Light textoNuevaBurbujaGralValoresLight'
                disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
                style={{
                  cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
                }}>
                <option value=''></option>
                {optionsPrioridad.map(option => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className='colModuloActualizacion'>
            <span className='nuevoSpanModuloGralValores'>Vencimiento</span>
            <input
              type='date'
              value={vencimiento}
              onChange={e => setVencimiento(e.target.value)}
              className={`nuevaBurbujaGralValoresLight textoNuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}
            />
          </div>
          <div className='colModuloActualizacion'>
            <label className='nuevoSpanModuloGralValores'>Nivel</label>
            <div
              className={`nuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}></div>
          </div>
        </div>
        <div className='rowModuloActualizacion mt-3'>
          <div className='colModuloActualizacion'>
            <span className='nuevoSpanModuloGralValores'>Monto</span>
            <input
              type='number'
              value={monto}
              onChange={e => setMonto(e.target.value)}
              className={`nuevaBurbujaGralValoresLight textoNuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}
            />
          </div>
          <div className='colModuloActualizacion'>
            <span className='nuevoSpanModuloGralValores'>Comercial</span>
            <input
              type='number'
              value={comercial}
              onChange={e => setComercial(e.target.value)}
              className={`nuevaBurbujaGralValoresLight textoNuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}
            />
          </div>
          <div className='colModuloActualizacion'>
            <span className='nuevoSpanModuloGralValores'>Porcentaje</span>
            <input
              type='number'
              value={porcentaje}
              onChange={e => setPorcentaje(e.target.value)}
              className={`nuevaBurbujaGralValoresLight textoNuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}
            />
          </div>
          <div className='colModuloActualizacion'>
            <span className='nuevoSpanModuloGralValores'>Aceptacion</span>
            <input
              type='date'
              value={aceptacion}
              onChange={e => setAceptacion(e.target.value)}
              className={`nuevaBurbujaGralValoresLight textoNuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}
            />
          </div>
          <div className='colModuloActualizacion'>
            <label className='nuevoSpanModuloGralValores'>Orden de Pago</label>
            <input
              type='number'
              value={ordenDePago}
              onChange={e => setOrdenDePago(e.target.value)}
              className={`nuevaBurbujaGralValoresLight textoNuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              disabled={cookies?.user?.titulo === 'lector' || cookies?.user?.depto === 'emision' ? true : !terminoCargarTodoImportante ? true : false}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}
            />
          </div>
        </div>
        <div className='d-flex align-items-center mt-3'>
          <div className='w-100'>
            <span className='spanDescripcionNuevaBurbujaGralValoresLight'>Descripcion Stro</span>
            <textarea
              className={`descripcionNuevaBurbujaGralValoresLight${cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? ' field-disabled' : ''}`}
              onChange={e => setDescStro(e.target.value)}
              value={descStro}
              disabled={cookies?.user?.titulo === 'lector' || !terminoCargarTodoImportante ? true : false}
              style={{
                cursor: cookies?.user?.depto === 'emision' || !terminoCargarTodoImportante ? 'not-allowed' : 'text',
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
}
